import React from 'react';
import YesNoFilter from './YesNoFilter';

export default function InvoiceSentFilter({ placeholder = 'Sent', name, value, onChange }) {
  return (
    <YesNoFilter icon="filter" clearable placeholder={placeholder} name={name} value={value} onChange={onChange} />
  );
}
